"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuccessIcon = exports.ResponseTitle = exports.ResponseContainer = exports.RequestSentContainer = exports.MainContainer = exports.List = exports.Information = exports.HeaderTitle = exports.HeaderSubtitle = exports.Header = exports.ErrorIcon = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const {
  colours
} = _uiKit.theme;
const Header = exports.Header = _styledComponents.default.div.withConfig({
  displayName: "RequestToolstyled__Header",
  componentId: "sc-16eg9o4-0"
})(["padding-bottom:16px;"]);
const HeaderTitle = exports.HeaderTitle = _styledComponents.default.h2.withConfig({
  displayName: "RequestToolstyled__HeaderTitle",
  componentId: "sc-16eg9o4-1"
})(["font-weight:600;font-size:18px;line-height:25px;color:", ";"], colours.PRIMARY_1);
const HeaderSubtitle = exports.HeaderSubtitle = _styledComponents.default.h3.withConfig({
  displayName: "RequestToolstyled__HeaderSubtitle",
  componentId: "sc-16eg9o4-2"
})(["font-weight:500;font-size:12px;line-height:18px;color:", ";"], colours.PRIMARY_1);
const List = exports.List = _styledComponents.default.ul.withConfig({
  displayName: "RequestToolstyled__List",
  componentId: "sc-16eg9o4-3"
})(["list-style:disc;margin:0 24px;font-size:13px;line-height:16px;"]);
const MainContainer = exports.MainContainer = _styledComponents.default.div.withConfig({
  displayName: "RequestToolstyled__MainContainer",
  componentId: "sc-16eg9o4-4"
})(["padding:16px 0;height:100%;min-height:280px;width:100%;"]);
const RequestSentContainer = exports.RequestSentContainer = (0, _styledComponents.default)(MainContainer).withConfig({
  displayName: "RequestToolstyled__RequestSentContainer",
  componentId: "sc-16eg9o4-5"
})(["display:flex;"]);
const Information = exports.Information = _styledComponents.default.div.withConfig({
  displayName: "RequestToolstyled__Information",
  componentId: "sc-16eg9o4-6"
})(["padding-bottom:16px;line-height:16px;font-size:13px;"]);
const ResponseContainer = exports.ResponseContainer = _styledComponents.default.div.withConfig({
  displayName: "RequestToolstyled__ResponseContainer",
  componentId: "sc-16eg9o4-7"
})(["display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center;width:100%;"]);
const SuccessIcon = exports.SuccessIcon = (0, _styledComponents.default)(_uiKit.Icon).withConfig({
  displayName: "RequestToolstyled__SuccessIcon",
  componentId: "sc-16eg9o4-8"
})(["color:", ";"], colours.SECONDARY_2);
const ErrorIcon = exports.ErrorIcon = (0, _styledComponents.default)(_uiKit.Icon).withConfig({
  displayName: "RequestToolstyled__ErrorIcon",
  componentId: "sc-16eg9o4-9"
})(["color:", ";"], colours.ERROR);
const ResponseTitle = exports.ResponseTitle = _styledComponents.default.div.withConfig({
  displayName: "RequestToolstyled__ResponseTitle",
  componentId: "sc-16eg9o4-10"
})(["padding-top:24px;width:268px;font-size:16px;line-height:22px;"]);